module.exports = __webpack_public_path__ + "img/73.c1c370d6.svg";